export default {
  business: '/business',
  addresses: '/user/addresses',
  externalClabe: '/loan/disbursement/clabe/external',
  bankNameByClabe: '/clabe/bankname',
  overallStatus: '/business/overall-status',
};
